// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1Oj3pow4ZbF_BUFfoQjPs7 _26QfI7vI01tTvo-McCGpQs"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Associations/location-active.css
// module id = 799
// module chunks = 0